import React from 'react';
import ConnectWithUs from '../../common_components/ConnectWithUs';
import Footer from '../../common_components/Footer';
import Header from '../../common_components/Header';
import "./AboutVita.css"
import registrar from "../../assets/img/registrat_sq (2).jpg";
import kalyan from "../../assets/img/faculty/kalyan_sq.jpg";
import hussain from "../../assets/img/faculty/hussain.jpg";
import dilip from "../../assets/img/faculty/dilip.jpg";
import tannishta from "../../assets/img/faculty/tannishtha_sq.jpg";
import TeamCard from "./TeamCard";

function AboutVita() {
  return (
    <div className="about_vitaa">
      <Header></Header>
      <div className="container-fluid content">
          <h2>Alumni Association Members</h2>
          <div className="team_section row">
              <TeamCard img={registrar} name="Dr. M. Jagadish Chandra" position="Registrar" email="mailto:mudiganti.jc@vitap.ac.in" linkedin="https://www.linkedin.com/in/jagadish-chandra-t-23b502102/"></TeamCard>
              <TeamCard img={kalyan} name="Mr. M. Kalyan Chakravarthi" position="Assistant Director Alumni Relations" email="mailto:kalyanchakravarthi.m@vitap.ac.in" linkedin="https://www.linkedin.com/in/kalyan-chakravarthi-bb6a3422/"></TeamCard>
              <TeamCard img={hussain} name="Dr. Hussain Syed" position="SCOPE" email="mailto:hussain.syed@vitap.ac.in" linkedin="https://www.linkedin.com/in/dr-hussain-syed-2a294315/"></TeamCard>
              <TeamCard img={dilip} name="Dr. Dilip Kumar Mohanty" position="SMEC" email="mailto:mohanty.dk@vitap.ac.in" linkedin="*"></TeamCard>
              <TeamCard img={tannishta} name="Dr. Tannistha Dasgupta" position="VISH" email="mailto:dasgupta.tannistha@vitap.ac.in" linkedin="https://www.linkedin.com/in/tannistha-dasgupta-95532910a/"></TeamCard>
          </div>
      </div>
      <ConnectWithUs></ConnectWithUs>
      <Footer></Footer>
  </div>
      // </div>
  );
}

export default AboutVita;
